/*
 * MEPP - A web application to guide patients and clinicians in the process of
 * facial palsy rehabilitation, with the help of the mirror effect and principles
 * of motor learning
 * Copyright (C) 2021 MEPP <info@mirroreffectplus.org>
 *
 * This file is part of MEPP.
 *
 * MEPP is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * MEPP is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with MEPP.  If not, see <http://www.gnu.org/licenses/>.
 */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { Language } from '@utils/constants';

import de from './de';
import en from './en';
import es from './es';
import fr from './fr';
import it from './it';
import pt from './pt';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    resources: { fr, en, de, es, it, pt },
    react: {
      wait: true,
    },
    detection: {
      order: ['localStorage', 'cookie'],
      lookupLocalStorage: 'language',
    },
  });

export const LANGUAGES = Object.freeze([
  Language.FR,
  Language.EN,
  Language.ES,
  Language.DE,
  Language.IT,
  Language.PT,
]);
export default i18n;
